/**
 * Definition of the DownloadUtil instance..
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */

import { baseURL } from './env'
import { getDownloadUtil } from '@amplify3/duplo-back-end'
export const downloader = getDownloadUtil(baseURL)
